import { Modal, Button } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { pickersLayoutClasses } from "@mui/x-date-pickers/PickersLayout";
import { StaticDateRangePicker } from "@mui/x-date-pickers-pro/StaticDateRangePicker";
import dayjs, { Dayjs } from "dayjs";
import { Dispatch, SetStateAction } from "react";
import * as React from "react";

interface DatePickerModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  startDate: Dayjs | null;
  setStartDate: Dispatch<SetStateAction<Dayjs | null>>;
  endDate: Dayjs | null;
  setEndDate: Dispatch<SetStateAction<Dayjs | null>>;
  onSubmit?: () => void;
}

export default function DatePicker({
  open,
  onClose,
  setOpen,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onSubmit,
}: DatePickerModalProps) {
  return (
    <Modal
      className="modal datepiker_modal"
      id="datepikerModal"
      aria-labelledby="datepiker-modal-title"
      aria-describedby="datepiker-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Select Date</h2>
          </div>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticDateRangePicker
              defaultValue={[startDate, endDate]}
              onChange={(newValue) => {
                setStartDate(newValue?.[0] ?? null);
                setEndDate(newValue?.[1] ?? null);
              }}
              sx={{
                [`.${pickersLayoutClasses.contentWrapper}`]: {
                  alignItems: "center",
                },
              }}
            />
          </LocalizationProvider>

          <div className="footer_btn_flex">
            <Button className="btn btn_white br" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button className="btn btn_secondary" onClick={onSubmit}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
